/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Shop_Image_Remove_AriaInputs */

const vi_shop_image_remove_aria = /** @type {(inputs: Shop_Image_Remove_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ ảnh ${i?.label}`)
};

/**

* @param {Shop_Image_Remove_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_image_remove_aria = /** @type {((inputs: Shop_Image_Remove_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Image_Remove_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_image_remove_aria(inputs)
});